if (!customElements.get('product-personalisation')) {
  customElements.define(
    'product-personalisation',
    class ProductPersonalisation extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.content = this.querySelector('.product-personalisation__content');
        this.expanded = this.details.open;
        this.summary.setAttribute('aria-expanded', String(this.expanded));
        this.content.inert = !this.expanded;
        this.instructions = this.querySelector('textarea');
        this.upload = this.querySelector('input[type="file"]');
        this.finish = this.querySelector('select');
        this.error = this.querySelector('.product-personalisation__error');
        this.form = this.finish.form;

        this.summary.addEventListener('click', (event) => {
          event.preventDefault();
          this.setExpanded(!this.expanded);
        }, options);
        this.addEventListener('input', () => this.validateFinish(), options);
        this.addEventListener('change', () => this.validateFinish(), options);
        // Dawn skips native form validation. Reveal invalid fields even if collapsed.
        this.form.addEventListener('submit', (event) => {
          this.validateFinish(true);
          const invalidField = [this.instructions, this.finish, this.upload].find(
            (field) => field && !field.validity.valid
          );
          if (!invalidField) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setExpanded(true, false);
          invalidField.focus();
          invalidField.reportValidity();
        }, { ...options, capture: true });
        this.form.addEventListener('formdata', (event) => {
          if (!this.finish.value) event.formData.delete(this.finish.name);
        }, options);
        this.form.addEventListener('reset', () => {
          this.finish.required = false;
          this.finish.setCustomValidity('');
          this.finish.removeAttribute('aria-invalid');
          this.error.hidden = true;
        }, options);
        this.validateFinish();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.animation?.cancel();
        this.animation = null;
        this.details.style.height = '';
        this.details.style.overflow = '';
      }

      setExpanded(expanded, animate = true) {
        const startHeight = this.details.getBoundingClientRect().height;
        this.animation?.cancel();
        this.animation = null;
        this.expanded = expanded;
        this.summary.setAttribute('aria-expanded', String(expanded));
        this.content.inert = !expanded;
        this.details.style.height = '';
        this.details.style.overflow = '';

        if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.details.open = expanded;
          return;
        }

        // Keep details open during closing so the browser can animate its contents.
        this.details.open = true;
        const endHeight = expanded
          ? this.details.getBoundingClientRect().height
          : this.summary.getBoundingClientRect().height;
        this.details.style.overflow = 'hidden';
        const animation = this.details.animate(
          { height: [`${startHeight}px`, `${endHeight}px`] },
          { duration: 280, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
        );
        this.animation = animation;
        animation.onfinish = () => {
          if (this.animation !== animation) return;
          this.details.open = expanded;
          this.details.style.overflow = '';
          this.animation = null;
        };
      }

      validateFinish(showError = false) {
        // An untouched section must still allow the standard, unpersonalised product.
        this.finish.required = Boolean(this.instructions.value.trim() || this.upload?.files.length);
        const missingFinish = this.finish.required && !this.finish.value;
        this.finish.setCustomValidity(missingFinish ? this.error.textContent.trim() : '');
        this.error.hidden = !(missingFinish && (showError || !this.error.hidden));
        this.finish.setAttribute('aria-invalid', String(!this.error.hidden));
      }
    }
  );
}
